// extracted by mini-css-extract-plugin
export default {"homePage":"home_homePage__2pur5","homeContent":"home_homeContent__iiSbB"};